import graphql__1de25cc5287c94c75b93 from "./__generated__/ContributeButton_participativeModule.graphql.js";import { useFragment } from "react-relay";
import { graphql } from "react-relay";
import { defineMessages } from "react-intl";

import ButtonLink from "../Buttons/ButtonLink";
import { useFormatMessageWithCustomization } from "../Intl/Context";
import { useRoutesContext } from "../Routes/RoutesContext";
import { isUnauthorized } from "../Utils/authorizations";

const ContributeButton = props => {
  const participativeModule = useFragment(
    ContributeButton_participativeModule,
    props.participativeModule
  );

  const { contributionsSubmissionAuthorized } = participativeModule.authorizations;

  const translateWithCustomization = useFormatMessageWithCustomization(
    participativeModule.visualization.customIntlMessages
  );
  const contributionFormButtonLabel = translateWithCustomization(
    intlMessages.contributionForm
  );

  const { pathFor } = useRoutesContext();

  // Only render contribution form submission link if the step authorizes users
  // to do so.
  //
  // If the user already submitted a contribution for the current call for
  // contributions, we show the button but disable it.
  //
  if (isUnauthorized(contributionsSubmissionAuthorized)) return null;

  const contributionFormPath = pathFor("newContribution", {
    participativeModuleSlug: participativeModule.slug
  });

  return (
    <ButtonLink
      href={contributionFormPath}
      className={props.className}
      label={contributionFormButtonLabel}
      iconClassName="icon-contribute"
      iconPosition="after"
      data-contribute-button
    />
  );
};

const ContributeButton_participativeModule = graphql__1de25cc5287c94c75b93;

export default ContributeButton;

const intlMessages = defineMessages({
  contributionForm: {
    id: "participativeModule.submitContribution",
    defaultMessage: "Contribuer",
    description: "Libellé du bouton de contribution"
  }
});
